export const firebaseConfig = {
    apiKey: "AIzaSyAvmkq0xdKoFTLry9RJMrLyCgaJeQEua_o",
    authDomain: "experientiel-csd-ot.firebaseapp.com",
    projectId: "experientiel-csd-ot",
    storageBucket: "experientiel-csd-ot.appspot.com",
    messagingSenderId: "121146016403",
    appId: "1:121146016403:web:601927ba74d70ce8820366",
    measurementId: "G-NR4QEB2YCT"
}
